export class MontlyMisModel{
    month: string
    year : number
    columnsInfo : ColumnsInfoModel[]

    constructor(month:string,year : number,columnsInfo:ColumnsInfoModel[]){
        this.month = month
        this.year = year
        this.columnsInfo = columnsInfo
    }
}

export class ColumnsInfoModel{
    columnName : string;
    value : number
    plantId : number
    month: number
    year : number
    constructor(columnName : string,value : number,plantId : number,month:number,year:number){
        this.columnName = columnName
        this.value = value
        this.plantId = plantId
        this.month = month
        this.year = year
    }
}